import SwiftSpinner from "./swift_spinner.gif";
import Hero_Store from "./Hero_Store.png";
import Hero_Top_up from "./Hero_Top_up.png";
import Hero_Medical_Expert from "./Hero_Medical_Expert.png";
import Condoms from "./Condoms.png";
import Creatine from "./creatine.jpg";
import Skincare from "./Skincare.png";
import Serum from "./serum.jpeg";
import CrediCard from "./CreditCard.svg";
import Headphones from "./Headphones.svg";
import Trophy from "./Trophy.svg";
import Package from "./Package.svg";
import Beverage_1 from "./Beverage_1.jpg";
import Beverage_2 from "./Beverage_2.jpg";
import Beverage_5 from "./Beverage_5.jpg";
import Condom_1 from "./Condom_1.png";
import Condom_2 from "./Condom_2.png";
import Durex from "./Durex.png";
import Drug_1 from "./Drug_1.png";
import Drug_2 from "./Drug_2.png";
import Drug_3 from "./Drug_3.png";
import Drug_4 from "./Drug_4.png";
import Drug_5 from "./Drug_5.jpg";
import Pregnanc_kit_1 from "./Pregnanc_kit_1.jpg";
import Skipping_rope from "./Skipping-rope.jpg";
import Logo from "./Logo.svg";
import Doctor_1 from "./Doctor_1.png";
import Airtel from "./Airtel.png";
import MTN from "./MTN.png";
import Glo from "./Glo.png";
import Star from "./star.png";
import SmallPromoBg from "./small-promo-bg.svg";
import DataIcon from "./data-icon.svg";
import AirtimeIcon from "./airtime-icon.svg";
import SeparatorImageOne from "./separator-banner-1.svg";
import SeparatorImageTwo from "./separator-banner-2.svg";
import x from "./x.svg";
import facebook from "./facebook.svg";
import instagram from "./instagram.svg";
import linkedin from "./linkedin.svg";
import paystackBanner from "./paystack_banner.svg";
import placeholder from "./placeholder-image.svg";
import complianceOne from "./compliance_img_1.svg";
import complianceTwo from "./compliance_img_2.svg";
import complianceThree from "./compliance_img_3.svg";
export const images = {
    complianceOne,
    complianceTwo,
    complianceThree,
    SwiftSpinner,
    x,
    facebook,
    instagram,
    linkedin,
    SeparatorImageOne,
    SeparatorImageTwo,
    DataIcon,
    AirtimeIcon,
    Hero_Top_up,
    Hero_Store,
    Hero_Medical_Expert,
    Condoms,
    Creatine,
    Serum,
    Skincare,
    CrediCard,
    Headphones,
    Trophy,
    Package,
    Beverage_1,
    Beverage_2,
    Beverage_5,
    Condom_1,
    Condom_2,
    Durex,
    Drug_1,
    Drug_2,
    Drug_3,
    Drug_4,
    Drug_5,
    Pregnanc_kit_1,
    Skipping_rope,
    Logo,
    Doctor_1,
    SmallPromoBg,
    Airtel,
    MTN,
    Glo,
    Star,
    paystackBanner,
    placeholder
};

//# sourceMappingURL=index.js.map